import { SceneContentType, SceneSourceSelection, SceneSourceType, sceneContentAllowedSources } from '../types'
import { Ref, computed } from '@vue/composition-api'
import { useCurrentCast } from '@/modules/casts/compositions'
import { hasInputsMixin } from '@/modules/classBuilder/mixins/hasInputs'
import { hasCastersMixin } from '@/modules/classBuilder/mixins/hasCasters'
import { Feature, hasFeature } from '@/featureFlags/featureFlags'
import { CastType } from '@/types/casts'

const useSceneSourceTypeSelection = (contentType?: Ref<SceneContentType>) => {

  const { currentCast } = useCurrentCast()

  const sceneSourcesAll = computed<SceneSourceSelection[]>(() => [
    {
      name: 'Live stream',
      icon: 'LiveStreams',
      description: 'Add SRT or RTMP streams',
      type: SceneSourceType.Broadcast,
      isDisabled: !hasInputsMixin(currentCast.value)
    },
    {
      name: 'Graphics',
      icon: 'Graphics',
      description: 'Add slates and graphics',
      type: SceneSourceType.Graphic,
      isDisabled: false
    },
    {
      name: 'Websource',
      icon: 'Websource',
      description: 'Add a webpage from URL',
      type: SceneSourceType.Websource,
      isDisabled: false
    },
    {
      name: 'Playlist',
      icon: 'Clips',
      description: 'Add video clips to a playlist',
      type: SceneSourceType.Playlist,
      isDisabled: !hasInputsMixin(currentCast.value)
        || !!currentCast.value?.hasAnySceneWithSourceType(SceneSourceType.Playlist)
    },
    {
      name: 'Guest',
      icon: 'user-star',
      description: 'Add a remote guest',
      type: SceneSourceType.Talent,
      isDisabled: !hasCastersMixin(currentCast.value)
    },
    {
      name: 'Station',
      icon: 'station',
      description: 'Add a remote camera station',
      type: SceneSourceType.Station,
      isDisabled: !hasCastersMixin(currentCast.value) || !hasFeature(Feature.FanRoom)
    },
    {
      name: 'Twitter',
      icon: 'twitter',
      description: 'Add tweets, hashtags and handles',
      type: SceneSourceType.Twitter,
      isDisabled: !!currentCast.value?.hasScenePresetWithSourceType(SceneSourceType.Twitter)
    },
    {
      name: 'Replay',
      icon: 'Replay',
      description: 'Add replay clips to a playlist',
      type: SceneSourceType.Replay,
      isDisabled: !hasInputsMixin(currentCast.value)
    },
    {
      name: 'Layout',
      icon: 'layout',
      description: 'Add a scene layout',
      type: SceneSourceType.Layout,
      isDisabled: false
    },
    {
      name: 'Fan room',
      icon: 'cheer',
      description: 'Add a fan room',
      type: SceneSourceType.Cast,
      isDisabled: currentCast.value?.castType !== CastType.StationSwitcher
    }
  ])

  const sceneSources = computed(() => sceneSourcesAll.value.filter((source) => {
    if (source.type === SceneSourceType.Cast && !hasFeature(Feature.FanRoom)) return false
    if (contentType === undefined) return true
    return sceneContentAllowedSources[contentType.value].includes(source.type)
  }))

  return {
    sceneSources
  }
}

export default useSceneSourceTypeSelection
